module.exports = {"632625100":"智青松多镇","632625200":"门堂乡","632625201":"哇赛乡","632625202":"索呼日麻乡","632625203":"白玉乡","632625204":"哇尔依乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632625.json
// module id = 3150
// module chunks = 0